import * as React from 'react';

import { RootStateDispatchContext, Message } from './global-controller';

function useSuccessController() {
  const dispatch = React.useContext(RootStateDispatchContext);

  return React.useCallback(
    (msg: Message) =>
      dispatch({
        type: 'messages.status',
        data: msg,
      }),
    [dispatch]
  );
}

export default useSuccessController;
